// src/components/sync/SyncNotice.js
import React, { useEffect, useRef, useState } from 'react'
import { Alert, Snackbar } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import { describePullSummary } from '../../utils/syncPanelModel'
import { dismissSyncNotice } from '../../redux/sync/actions'

// Acima do overlay de loading (zIndex 100000 em Loading.tsx / SyncProgressOverlay).
const Z = 100001
// Erro/aviso ficam mais tempo (o usuário precisa ler e agir); sucesso/info somem logo.
const ERROR_HIDE_MS = 15000
const QUICK_HIDE_MS = 6000
const isQuick = (severity) => severity === 'success' || severity === 'info'

/**
 * Substitui o alert() do warnPull: erro persiste no estado (o painel também o mostra) e aqui
 * aparece como Snackbar; sucesso (resumo do download) só quando o usuário iniciou a operação.
 */
export default function SyncNotice() {
  const dispatch = useDispatch()
  const notice = useSelector((s) => s.sync.notice)
  const lastPull = useSelector((s) => s.sync.lastPull)
  const [hiddenId, setHiddenId] = useState(null)
  const [success, setSuccess] = useState(null)
  const seenPullAt = useRef(lastPull?.at ?? null)
  // Ao descartar um aviso do estado, mantém o último texto até o fim da animação de saída.
  const lastNotice = useRef(null)
  if (notice) lastNotice.current = notice
  const shown = notice ?? lastNotice.current

  useEffect(() => {
    if (lastPull && lastPull.at !== seenPullAt.current) {
      seenPullAt.current = lastPull.at
      if (lastPull.userInitiated) setSuccess(lastPull)
    }
  }, [lastPull])

  const errorOpen = !!notice && hiddenId !== notice.id
  const closeError = (_e, reason) => {
    if (reason === 'clickaway' || !notice) return
    // Aviso de sucesso é só um retorno: ao sumir, sai também do estado (o painel não o guarda).
    if (isQuick(notice.severity)) dispatch(dismissSyncNotice())
    else setHiddenId(notice.id)
  }

  return (
    <>
      <Snackbar
        open={errorOpen}
        onClose={closeError}
        autoHideDuration={
          isQuick(shown?.severity) ? QUICK_HIDE_MS : ERROR_HIDE_MS
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: Z }}
      >
        <Alert
          severity={shown?.severity ?? 'error'}
          variant='filled'
          onClose={closeError}
          role='alert'
        >
          {shown?.text}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!success}
        onClose={() => setSuccess(null)}
        autoHideDuration={8000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: Z }}
      >
        <Alert
          severity='success'
          variant='filled'
          onClose={() => setSuccess(null)}
        >
          {success ? describePullSummary(success) : ''}
        </Alert>
      </Snackbar>
    </>
  )
}
